import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=3bb99b7b&scoped=true&"
import script from "./ContentDetail.vue?vue&type=script&lang=js&"
export * from "./ContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=3bb99b7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb99b7b",
  null
  
)

export default component.exports